module.exports = __webpack_public_path__ + "img/Geek.53c56d3c.png";